import React, { ReactElement, FunctionComponent, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import CaptionFont from '../../../Theme/Fonts/Caption'
import LinkProps from '../../../Link/LinkProps'
import FavoriteImage from './image/FavoriteImage'

type IconProps = {
    name: string
    fontSize?: number
    color?: string
    marginTop?: number
    marginBottom?: number
}

export type FavoriteItemProps = {
    /** text which is shown below the icon */
    label: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /** callback when the user presses on the component (only available if element is not in the remove state)
     *
     * @TJS-type function
     * */
    onPress?: () => void
    /** callback when the user presses on the component for a long time (only available if element is not in the remove state)
     *
     * @TJS-type function
     * */
    onLongPress?: () => void
    /** the url of the image */
    imageUrl?: string
    /** icon props use instead of imageUrl */
    iconProps?: IconProps
    /** info about imageUrl for seo */
    alt?: string
    /** specific type of the favorite item
     *
     * @defaultValue 'DEFAULT'
     * */
    type?: 'PLAYER' | 'TEAM' | 'ICON' | 'DEFAULT'
    /** boolean to determine if the element is in the remove state (remove icon is shown) or not */
    showRemove?: boolean
} & LinkProps &
    TestID

const FavoriteItem: FunctionComponent<FavoriteItemProps> = ({
    label,
    iconProps,
    imageUrl,
    alt,
    type = 'DEFAULT',
    href,
    onPress,
    onLongPress,
    showRemove,
    testID,
    webRel,
}): ReactElement => {
    return (
        <Grid noExpand width={78} position="relative" testID={testID}>
            {showRemove ? (
                <>
                    <FavoriteImage
                        imageUrl={imageUrl}
                        alt={alt}
                        type={type}
                        iconProps={iconProps}
                    />
                    <Grid
                        center
                        width={26}
                        height={26}
                        position="absolute"
                        borderRadius={13}
                        zIndex={2}
                        backgroundColor="pearl"
                    >
                        <FontelloIcon name="close-x-circle-active" fontSize={20} color="onyx" />
                    </Grid>
                    <CaptionFont color="onyx" textAlign="center" numberOfLines={2}>
                        {label}
                    </CaptionFont>
                </>
            ) : (
                <Touchable href={href} onPress={onPress} onLongPress={onLongPress} webRel={webRel}>
                    <Grid noExpand>
                        <FavoriteImage
                            imageUrl={imageUrl}
                            alt={alt}
                            type={type}
                            iconProps={iconProps}
                        />
                        <CaptionFont color="onyx" textAlign="center" numberOfLines={2}>
                            {label}
                        </CaptionFont>
                    </Grid>
                </Touchable>
            )}
        </Grid>
    )
}

export default memo(FavoriteItem)
